import isEqual from "lodash/isEqual";
import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import {
  getEffectiveDefaultInsightsLens,
  getOneRmSummaryLifts,
} from "../../../constants/default-insights-lens";
import BackArrowButton from "../../../parts/back-arrow-button";
import ExerciseClipboardContent from "../../../parts/ExerciseClipboardContent";
import InsertUndoToast from "../../../parts/InsertUndoToast";
import SaveInputButtons from "../../../parts/SaveInputButtons";
import SvgIcon from "../../../parts/SvgIcon";
import ToolTip from "../../../parts/tooltip";
import { RillContext } from "../../../rill/RillReact/share/base";
import { savedWorkoutListReturnQuery } from "../../../utils/saved-workout-list-query";
import { isValidVideoLink } from "../../../utils/string-helpers";
import AddOptionDropdown from "./components/AddOptionDropdown";
import EditorWeekColumn from "./components/EditorWeekColumn";
import ReadOnlyWeekColumn from "./components/ReadOnlyWeekColumn";
import WeekConfiguration from "./components/WeekConfiguration";
import WorkoutConfiguration from "./components/WorkoutConfiguration";
import ProgramInsightsShell from "./program-insights/components/ProgramInsightsShell";
import { buildTeamsProgramInsightsInput } from "./program-insights/utils/inputs/buildTeamsProgramInsightsInput";

const ONE_RM_LIFT_LABELS = {
  squat: "Squat",
  bench: "Bench",
  deadlift: "Deadlift",
  snatch: "Snatch",
  clean: "Clean",
  jerk: "Jerk",
};

class View extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      exercises: props.exercises,
      localEditExercises: props.exercises,
      name: context.locals.program.name || "",
      description: context.locals.program.description || "",
      video: context.locals.program.video || "",
      editingName: false,
      editingDescription: false,
      editingVideo: false,
      editingWorkouts: [],
      selectedWeeks: [],
      settingsOpened: false,
      configuration: false,
      nWeekSelected: 1,
      viewportWidth: null,
      isAddWeekOptionOpened: false,
    };
    this.checkChange = this.checkChange.bind(this);
    this.handleAddWeek = this.handleAddWeek.bind(this);
    this.handleAddWeekOptions = this.handleAddWeekOptions.bind(this);
    this.handleAddWeekOptionClick = this.handleAddWeekOptionClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateExercise = this.updateExercise.bind(this);
    this.updateExercises = this.updateExercises.bind(this);
    this.deleteExercise = this.deleteExercise.bind(this);
    this.updateOrderExercises = this.updateOrderExercises.bind(this);
    this.submitChange = this.submitChange.bind(this);
    this.workoutOpacityCallback = this.workoutOpacityCallback.bind(this);
    this.handleSelectWeek = this.handleSelectWeek.bind(this);
    this.handleDeleteWeeks = this.handleDeleteWeeks.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.mainSectionRef = React.createRef();
  }

  updateDimensions() {
    this.setState(
      (prevState) =>
        Object.assign({}, prevState, {
          viewportWidth: window.innerWidth,
        }),
      this.handleDashboardPaddings
    );
  }

  componentDidMount() {
    this.setExerciseListHeight();

    !this.state.viewportWidth
      ? this.setState((prevState) =>
          Object.assign({}, prevState, {
            viewportWidth: window.innerWidth,
          })
        )
      : null;

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isEqual(this.context.locals.editExercises, prevState.localEditExercises)
    ) {
      this.setState({
        exercises: this.context.locals.editExercises,
        localEditExercises: this.context.locals.editExercises,
      });
    }

    this.setExerciseListHeight();
  }

  updateExercise(exercise) {
    const copyExercises = [...this.state.exercises];
    const exerciseIndex = copyExercises.findIndex(
      (elem) => elem._id === exercise._id
    );
    copyExercises[exerciseIndex] = exercise;
    this.setState({ exercises: copyExercises });
  }

  updateExercises(exercises) {
    const copyExercises = [...this.state.exercises];
    exercises.forEach((exercise) => {
      const exerciseIndex = copyExercises.findIndex(
        (elem) => elem._id === exercise._id
      );
      copyExercises[exerciseIndex] = exercise;
    });

    this.setState({ exercises: copyExercises });
  }

  updateOrderExercises(firstExercise, secondExercise) {
    const copyExercises = [...this.state.exercises];
    copyExercises.forEach((exercise, exerciseIndex) => {
      if (exercise._id === firstExercise._id) {
        copyExercises[exerciseIndex] = secondExercise;
      } else if (exercise._id === secondExercise._id) {
        copyExercises[exerciseIndex] = firstExercise;
      }
    });

    this.setState({ exercises: copyExercises });
  }

  deleteExercise(exerciseId) {
    const copyExercises = [...this.state.exercises];
    const exerciseIndex = copyExercises.findIndex(
      (elem) => elem._id === exerciseId
    );

    copyExercises.splice(exerciseIndex, 1);
    this.setState({ exercises: copyExercises });
  }

  /**
   * Function to add a single week (clicking the add week button)
   * @param {*} e
   * @param {*} isCoach
   * @param {*} numberOfWeeks
   * @param {*} sessionsPerWeek
   * @param {*} cycle
   * @param {*} programNumber
   * @param {*} isAddWeekOptionOpened
   */
  handleAddWeek(
    e,
    isCoach,
    numberOfWeeks,
    sessionsPerWeek,
    cycle,
    programNumber,
    isAddWeekOptionOpened
  ) {
    e.preventDefault();
    this.handleSubmitAddWeeks({
      isCoach,
      sessionsPerWeek,
      newWeeks: 1,
      cycle,
      programNumber,
      initNewWeek: numberOfWeeks,
      closeDropdown: isAddWeekOptionOpened,
    });
  }

  /**
   * Function to add multiple weeks (clicking a option from the add weeks list)
   * @param {*} e
   * @param {*} isCoach
   * @param {*} numberOfWeeks
   * @param {*} sessionsPerWeek
   * @param {*} cycle
   * @param {*} programNumber
   * @param {*} newWeeks
   */
  handleAddWeekOptionClick = (
    e,
    isCoach,
    numberOfWeeks,
    sessionsPerWeek,
    cycle,
    programNumber,
    newWeeks
  ) => {
    e.preventDefault();
    this.handleSubmitAddWeeks({
      isCoach,
      sessionsPerWeek,
      newWeeks,
      cycle,
      programNumber,
      initNewWeek: numberOfWeeks,
      closeDropdown: true,
    });
  };

  /**
   * Call the API request to add weeks
   * @param {*} param0
   */
  handleSubmitAddWeeks({
    isCoach,
    sessionsPerWeek,
    newWeeks,
    cycle,
    programNumber,
    initNewWeek,
    closeDropdown = false,
  }) {
    const { t } = this.props;
    const proceed = () => {
      const weekLabel =
        newWeeks === 1
          ? t("athlete-portal:programs.aNewWeek")
          : t("athlete-portal:programs.newWeeks", { count: newWeeks });
      if (
        confirm(t("athlete-portal:programs.confirmAddWeeks", { weekLabel }))
      ) {
        const body = {
          cycle,
          program: programNumber,
          initNewWeek,
          newWeeks,
        };
        if (isCoach) {
          body.sessionsPerWeek = sessionsPerWeek;
        }
        submit(`/actions/cycle/program/addWeek`, {
          method: "POST",
          body,
        });
      }
    };

    if (closeDropdown) {
      this.setState({ isAddWeekOptionOpened: false }, proceed);
    } else {
      proceed();
    }
  }

  handleAddWeekOptions = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      const eventType = e.type;

      if (eventType === "mouseenter") {
        this.setState({ isAddWeekOptionOpened: true });
      } else if (eventType === "mouseleave") {
        this.setState({ isAddWeekOptionOpened: false });
      } else if (eventType === "click") {
        this.setState((prevState) => ({
          isAddWeekOptionOpened: !prevState.isAddWeekOptionOpened,
        }));
      }
    }
  };

  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    });
  }

  checkChange(type) {
    const {
      locals: { program },
    } = this.context;
    if (this.state[type] !== program[type]) return true;
    return false;
  }

  submitChange(body) {
    const activeUser =
      this.context.locals.athlete || this.context.locals.activeUser;
    const programNumber = this.context.locals.query.program;
    const cycleId = this.context.locals.params.cycleId;

    submit(
      `/actions/cycle/edit/program/${cycleId}?program=${programNumber}&athlete=${activeUser}`,
      {
        method: "POST",
        body,
      }
    );
  }

  workoutOpacityCallback({ type = "add", keyId = "" }) {
    const result =
      type === "add"
        ? [...this.state.editingWorkouts, keyId]
        : this.state.editingWorkouts.filter((workout) => workout !== keyId);
    this.setState({
      editingWorkouts: result,
    });
  }

  setExerciseListHeight() {
    for (let n = 0; n < 7; n++) {
      const className = `workout-${n + 1}-list`;
      // gets one row of workouts
      const elements = Array.from(document.getElementsByClassName(className));

      elements.forEach((el) => {
        el.style.height = "auto";
      });
      const elementsHeights = elements.map((el) => el.clientHeight);
      const maxHeight = Math.max(...elementsHeights);
      // set the height of all elements in the row to the same height as the tallest element in it
      elements.forEach((el) => {
        el.style.height = `${maxHeight}px`;
      });
    }
  }

  handleSelectWeek(week) {
    this.setState((prevState) => {
      if (prevState.selectedWeeks.includes(week)) {
        return {
          ...prevState,
          selectedWeeks: prevState.selectedWeeks.filter(
            (_week) => _week !== week
          ),
        };
      } else {
        return {
          ...prevState,
          selectedWeeks: [...prevState.selectedWeeks, week],
        };
      }
    });
  }

  handleDeleteWeeks(e) {
    e.preventDefault();
    const { selectedWeeks } = this.state;
    const { editCycle, query } = this.context.locals;
    if (
      !selectedWeeks?.length ||
      !confirm(
        this.props.t("athlete-portal:programs.confirmDeleteWeeks", {
          count: selectedWeeks.length,
        })
      )
    ) {
      return;
    }
    this.setState({ selectedWeeks: [] });
    submit("/actions/cycle/program/delete-weeks", {
      method: "POST",
      body: {
        cycle: editCycle._id,
        program: query.program,
        selectedWeeks,
      },
    });
  }

  handleDismiss(e, type, key) {
    e.preventDefault();
    const initialValue = this.context.locals.program[key];
    this.setState({ [type]: false, [key]: initialValue });
  }

  render() {
    const { locals } = this.context;
    const { t } = this.props;
    const {
      editingName,
      editingDescription,
      settingsOpened,
      configuration,
      editingVideo,
    } = this.state;
    // locals.athlete is preloaded in the ensureCoach middleware
    const activeUser = locals.athlete || locals.activeUser;
    // A link without ?program= (e.g. opened from the import modal) edits the
    // first week; the links built from this number must never read "undefined".
    const programNumber = locals.query.program || locals.program?.order || 1;
    const exercisesInClipboard = locals.query.exercisesInClipboard;
    const cycleId = locals.params.cycleId;
    // Fixes MSB-947
    const scrollTo = locals.query.scrollTo;

    //Group sessions into weeks
    const weeks = locals.weeks;
    const previousWeeks = locals.previousWeeks;
    const numberOfWeeks = Object.keys(weeks).length;
    const remainingWeeks = Array.from(
      { length: Math.max(12 - numberOfWeeks, 0) },
      (_, i) => {
        const count = i + 1;
        return {
          text:
            count === 1
              ? t("athlete-portal:programs.addCountWeek", { count: 1 })
              : t("athlete-portal:programs.addCountWeeks", { count }),
          value: count,
        };
      }
    );

    // Ensure the activeWeek param is within the available weeks
    if (locals.activeWeek > numberOfWeeks - 1)
      locals.activeWeek = numberOfWeeks;
    if (locals.activeWeek < 1) locals.activeWeek = 1;

    const isCoach = locals.editCycle.type !== "user";
    const effectiveInsightsLens = getEffectiveDefaultInsightsLens(
      locals.activeUser,
      locals.organizationOwner,
      locals.clientConfiguration
    );
    const sessionsPerWeek = weeks["1"].length;

    // Check if inside athlete-portal for showing the RM's athlete at the top
    const isAthletePortal = locals.pathname.startsWith("/athlete-portal/");
    let athleteName;
    if (isAthletePortal) {
      athleteName = locals.athlete.name;
    }
    // Olympic lifts are optional on the athlete, so only the ones with a value are listed
    const optionalOneRmLifts = new Set(["snatch", "clean", "jerk"]);
    const oneRmSummary = isAthletePortal
      ? getOneRmSummaryLifts(effectiveInsightsLens)
          .map((lift) => ({
            lift,
            value: locals.fromMetric(locals.athlete.repMaximums?.[lift] ?? 0),
          }))
          .filter(
            ({ lift, value }) => !optionalOneRmLifts.has(lift) || value > 0
          )
      : [];

    const unit = locals.activeUser.units === "imperial" ? "lb" : "kg";
    const storeType = locals.editCycle.storeType || "programs";
    const isTemplatesPage = !(locals.pathname.indexOf("/templates/") === -1);

    const handleReturnButton = (athleteId) => {
      // A flexible program is edited from its own manager page, so go back
      // there rather than to the athlete's program grid.
      if (storeType === "flexible") {
        // The athlete id is required, not optional: ensureCoach redirects to
        // the athletes list without it, so fall back to the query we arrived
        // with rather than dropping the param.
        const flexibleAthlete = athleteId || locals.query?.athlete;
        submit(`/athlete-portal/programs/flexible-program/${cycleId}`, {
          method: "GET",
          body: flexibleAthlete ? { athlete: flexibleAthlete } : {},
        });
        return;
      }

      if (athleteId) {
        let body = { athlete: athleteId };

        if (locals.query.organizationCoach) {
          body = { ...body, organizationCoach: locals.query.organizationCoach };
        }

        submit(`/athlete-portal/programs/`, {
          method: "GET",
          body,
        });
      } else if (locals.pathname.includes("store") && storeType !== "teams") {
        submit(`/coaching-portal/store`, {
          method: "GET",
          body: { status: "draft", storeType: storeType },
        });
      } else if (locals.pathname.includes("store") && storeType === "teams") {
        submit(`/coaching-portal/store/teams/${cycleId}`, {
          method: "GET",
        });
      } else if (
        locals.pathname.includes("templates") &&
        storeType === "teams"
      ) {
        submit(`/coaching-portal/templates/teams/${cycleId}`, {
          method: "GET",
        });
      } else if (
        locals.pathname.includes("templates") &&
        storeType === "single-workout"
      ) {
        // folderId and the other Saved Workouts list params ride on this
        // route's query. status is included only when that list had it.
        submit(`/coaching-portal/all-templates`, {
          method: "GET",
          body: savedWorkoutListReturnQuery(locals.query),
        });
      } else {
        submit(`/coaching-portal/all-templates`, {
          method: "GET",
          body: {
            owner: "coach",
            tabView: "programs-tab",
            templateView: "programs",
          },
        });
      }
    };

    const selectedWeeksLength = this.state.selectedWeeks?.length;
    const nameDisabled = !this.checkChange("name");
    const descriptionDisabled = !this.checkChange("description");
    const videoDisabled = !this.checkChange("video");

    // istg there's a better way but I'm too deep now
    const notSingleWorkout = storeType !== "single-workout";
    const isFlexible = storeType === "flexible";
    // Teams and flexible programs are both authored a week at a time, so they
    // share the week labelling and the previous-vs-current column layout.
    const isTeams = storeType === "teams" || isFlexible;
    const isProgram = !storeType || storeType === "programs";
    const queryIsWeekAuthoring = ["teams", "flexible"].includes(
      locals.query.storeType
    );
    const showProgramInsightsShell =
      isCoach && locals.query.readOnly !== true && notSingleWorkout;

    // Constant to know if we should show the previous program column in the program insights
    const showTeamsPreviousProgramColumn =
      isTeams && locals.previousProgram && locals.query.readOnly !== true;

    // Constant used to build the program insights input for teams
    const teamsProgramInsightsInput = showTeamsPreviousProgramColumn
      ? buildTeamsProgramInsightsInput({
          previousWeeks,
          weeks,
          previousExercises: locals.editPreviousExercises,
          currentExercises: this.state.exercises,
          previousProgram: locals.previousProgram,
          currentProgram: locals.program,
        })
      : null;

    return (
      <main
        className={`Program-Editor program-builder${
          showProgramInsightsShell ? " Program-Editor--insights-shell" : ""
        }`}
      >
        <header>
          <hgroup className={`${notSingleWorkout ? "" : "items-center"}`}>
            <BackArrowButton
              onBack={() => handleReturnButton(locals?.athlete?._id)}
            />

            {!notSingleWorkout && <p>{locals.editCycle.name}</p>}

            {notSingleWorkout && (
              <div className="mobile-hidden">
                <div className="header-input">
                  <label htmlFor="name">
                    {isTeams
                      ? t("athlete-portal:programs.weekName")
                      : t("athlete-portal:programs.blockName")}
                  </label>

                  <input
                    type="text"
                    id="name"
                    name="name"
                    className={editingName ? "editing" : ""}
                    value={this.state.name}
                    onChange={this.handleChange}
                    onFocus={() => this.setState({ editingName: true })}
                  />
                  <SaveInputButtons
                    enabled={editingName}
                    handleSave={(e) => {
                      e.preventDefault();
                      this.submitChange({ name: this.state.name });
                      this.setState({ editingName: false });
                    }}
                    handleDismiss={(e) =>
                      this.handleDismiss(e, "editingName", "name")
                    }
                    saveDisabled={nameDisabled}
                  />
                </div>

                <div className="header-input">
                  <label htmlFor="description">
                    {isTeams
                      ? t("athlete-portal:programs.weekDescription")
                      : t("athlete-portal:programs.blockDescription")}
                  </label>

                  <input
                    type="text"
                    id="description"
                    name="description"
                    className={editingDescription ? "editing" : ""}
                    value={this.state.description}
                    onChange={this.handleChange}
                    onFocus={() => this.setState({ editingDescription: true })}
                  />
                  <SaveInputButtons
                    enabled={editingDescription}
                    handleSave={(e) => {
                      e.preventDefault();
                      this.submitChange({
                        description: this.state.description,
                      });
                      this.setState({ editingDescription: false });
                    }}
                    handleDismiss={(e) =>
                      this.handleDismiss(e, "editingDescription", "description")
                    }
                    saveDisabled={descriptionDisabled}
                  />
                </div>

                {(isTeams || isProgram) && (
                  <div className="header-input">
                    <label htmlFor="video">
                      {isTeams
                        ? t("athlete-portal:programs.weekVideoOptional")
                        : t("athlete-portal:programs.programVideoOptional")}
                    </label>

                    <input
                      type="text"
                      id="video"
                      name="video"
                      className={editingVideo ? "editing" : ""}
                      value={this.state.video}
                      onChange={this.handleChange}
                      onFocus={() => this.setState({ editingVideo: true })}
                    />
                    <SaveInputButtons
                      enabled={editingVideo}
                      handleSave={(e) => {
                        e.preventDefault();
                        if (
                          this.state.video &&
                          !isValidVideoLink(this.state.video)
                        ) {
                          alert("Please enter a valid YouTube or Loom URL.");
                          return;
                        }
                        this.submitChange({
                          video: this.state.video,
                        });
                        this.setState({ editingVideo: false });
                      }}
                      handleDismiss={(e) =>
                        this.handleDismiss(e, "editingVideo", "video")
                      }
                      saveDisabled={videoDisabled}
                    />
                  </div>
                )}
              </div>
            )}

            {notSingleWorkout && (
              <div className="only-show-mobile">
                <span>{this.state.name}</span>
                <span>{this.state.description}</span>
              </div>
            )}
            {isTemplatesPage && storeType !== "teams" && (
              <ToolTip
                id="template-tooltip"
                body={t("athlete-portal:programs.templateTooltip", {
                  role: activeUser.referAsClients
                    ? t("athlete-portal:programs.client")
                    : t("athlete-portal:programs.athlete"),
                })}
              >
                <span
                  className={
                    storeType === "single-workout"
                      ? "program-editor-header-tooltip-hint mt-0!"
                      : "program-editor-header-tooltip-hint"
                  }
                >
                  ?
                </span>
              </ToolTip>
            )}
            {isAthletePortal && !isFlexible && oneRmSummary.length > 0 && (
              <div className="rm-details">
                <span>{t("athlete-portal:programs.rmsLabel")}</span>
                {oneRmSummary.map(({ lift, value }) => (
                  <span key={lift}>
                    <b>{ONE_RM_LIFT_LABELS[lift]}</b> {`${value} ${unit}`}
                  </span>
                ))}
              </div>
            )}
          </hgroup>

          <hgroup>
            {selectedWeeksLength ? (
              <>
                <button
                  data-button-type="secondary"
                  onClick={() => this.setState({ selectedWeeks: [] })}
                >
                  {t("common:cancel")}
                </button>
                <button
                  data-button-type="secondary"
                  className="text-(--danger)!"
                  onClick={this.handleDeleteWeeks}
                >
                  <SvgIcon
                    classNames="mr-2"
                    src={"/img/new-icons/red-trash.svg"}
                    noFilterOnLight={true}
                  />
                  {t("athlete-portal:programs.deleteWeeks", {
                    count: selectedWeeksLength,
                  })}
                </button>
              </>
            ) : (
              <>
                {numberOfWeeks < 12 && isProgram && (
                  <div
                    className="add-week-dropdown-wrapper"
                    onMouseLeave={this.handleAddWeekOptions}
                  >
                    <button
                      data-button-type="primary"
                      onClick={(e) =>
                        this.handleAddWeek(
                          e,
                          isCoach,
                          numberOfWeeks,
                          sessionsPerWeek,
                          locals.editCycle,
                          programNumber,
                          this.state.isAddWeekOptionOpened
                        )
                      }
                    >
                      <span>{t("athlete-portal:programs.addWeek")}</span>
                      <SvgIcon
                        src={
                          this.state.isAddWeekOptionOpened
                            ? "/img/svg/angle-up.svg"
                            : "/img/svg/angle-down.svg"
                        }
                        noFilterOnLight={true}
                        onClickFn={this.handleAddWeekOptions}
                        onMouseEnterFn={this.handleAddWeekOptions}
                      />
                    </button>
                    {this.state.isAddWeekOptionOpened && (
                      <AddOptionDropdown
                        options={remainingWeeks}
                        handleAddOptionClick={(e, value) =>
                          this.handleAddWeekOptionClick(
                            e,
                            isCoach,
                            numberOfWeeks,
                            sessionsPerWeek,
                            locals.editCycle,
                            programNumber,
                            value
                          )
                        }
                      />
                    )}
                  </div>
                )}

                <div>
                  <div className="only-show-mobile">
                    <ToolTip>
                      <a
                        data-button-type="secondary"
                        role="button"
                        href={`/actions/refresh/?modal[type]=progression&week=${this.state.nWeekSelected}&program=${programNumber}&cycle=${locals.editCycle._id}&type=week`}
                      >
                        <SvgIcon src="/img/new-icons/percentage-square.svg" />
                      </a>
                    </ToolTip>
                    <ToolTip>
                      <a
                        data-button-type="secondary"
                        role="button"
                        href={`/actions/refresh/?modal[type]=duplicate-week&week=${this.state.nWeekSelected}`}
                      >
                        <SvgIcon src="/img/new-icons/duplicate.svg" />
                      </a>
                    </ToolTip>

                    <ToolTip
                      id={`delete-week-${this.state.nWeekSelected.toString()}`}
                    >
                      <a
                        data-button-type="secondary"
                        role="button"
                        href={`/actions/cycle/delete-week/${locals.editCycle._id}/${programNumber}/${this.state.nWeekSelected}`}
                      >
                        <SvgIcon
                          src="/img/new-icons/red-trash.svg"
                          noFilterOnLight
                        />
                      </a>
                    </ToolTip>
                  </div>

                  {!isFlexible && (
                    <details role="list" open={settingsOpened}>
                      <summary
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.setState({ settingsOpened: !settingsOpened });
                        }}
                        onBlur={(e) => {
                          if (e.relatedTarget?.role === "listbox") return;
                          e.preventDefault();
                          this.setState({ settingsOpened: false });
                        }}
                        aria-haspopup="listbox"
                      >
                        <span>{t("athlete-portal:programs.more")}</span>
                        <SvgIcon
                          src={
                            this.state.viewportWidth > 960
                              ? settingsOpened
                                ? "/img/svg/angle-up.svg"
                                : "/img/svg/angle-down.svg"
                              : "/img/new-icons/menu.svg"
                          }
                        />
                      </summary>
                      <ul
                        role="listbox"
                        className={settingsOpened ? "opened" : ""}
                      >
                        <div className="list-title">
                          <span>{t("athlete-portal:programs.settings")}</span>
                          <div />
                        </div>
                        <li
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            this.setState({ settingsOpened: false });
                            submit("/actions/refresh?", {
                              method: "GET",
                              body: {
                                "modal[type]": "program-settings",
                                storeType,
                              },
                            });
                          }}
                        >
                          <span>
                            {t("athlete-portal:programs.editProgramSettings")}
                          </span>
                          <SvgIcon src="/img/new-icons/export.svg" />
                        </li>
                        {notSingleWorkout && (
                          <>
                            {/* Teams doesn't need this */}
                            {isProgram && (
                              <li
                                onMouseDown={(e) =>
                                  this.setState({ configuration: "weeks" })
                                }
                              >
                                <span>
                                  {t("athlete-portal:programs.configureWeeks")}
                                </span>
                                <SvgIcon src="/img/new-icons/settings.svg" />
                              </li>
                            )}
                            <li
                              onMouseDown={(e) =>
                                this.setState({ configuration: "workouts" })
                              }
                            >
                              <span>
                                {t("athlete-portal:programs.configureWorkouts")}
                              </span>
                              <SvgIcon src="/img/new-icons/settings.svg" />
                            </li>
                          </>
                        )}
                      </ul>
                    </details>
                  )}
                </div>
              </>
            )}
          </hgroup>
        </header>

        <div
          className={`ProgramEditor-insights-body${
            showProgramInsightsShell
              ? " ProgramEditor-insights-body--stacked"
              : ""
          }`}
        >
          <section ref={this.mainSectionRef} className="Main">
            {this.state.viewportWidth > 960 && (
              <ul
                className={`weeks ${
                  numberOfWeeks == locals.activeWeek ? "alt-last" : ""
                } mobile-hidden`}
              >
                {queryIsWeekAuthoring &&
                  locals.previousProgram &&
                  locals.query.readOnly !== true && (
                    <ReadOnlyWeekColumn
                      week={previousWeeks["1"]}
                      cycle={locals.editCycle}
                      program={locals.previousProgram}
                      programNumber={locals.previousProgram.order}
                      programOrder={locals.previousProgram.order}
                      activeWeek={locals.previousActiveWeek}
                      column={0}
                      fromMetric={locals.fromMetric}
                      activeUser={activeUser}
                      numberOfWeeks={numberOfWeeks}
                      scrollTo={scrollTo}
                      exercises={locals.editPreviousExercises || []}
                    />
                  )}

                {queryIsWeekAuthoring &&
                  locals.query.readOnly === true &&
                  Array.from({ length: numberOfWeeks }, (_, i) => i + 1).map(
                    (nWeek) => (
                      <ReadOnlyWeekColumn
                        key={`week_column_program_editor_${nWeek.toString()}`}
                        week={weeks[nWeek.toString()]}
                        exercises={this.state.exercises || []}
                        cycle={locals.editCycle}
                        program={locals.program}
                        programNumber={programNumber}
                        programOrder={locals.query.program}
                        activeWeek={locals.activeWeek}
                        column={nWeek.toString()}
                        fromMetric={locals.fromMetric}
                        activeUser={activeUser}
                        numberOfWeeks={numberOfWeeks}
                        scrollTo={scrollTo}
                        updateExercise={this.updateExercise}
                        deleteExercise={this.deleteExercise}
                        updateExercises={this.updateExercises}
                        updateOrderExercises={this.updateOrderExercises}
                        workoutOpacityCallback={this.workoutOpacityCallback}
                        editingWorkouts={this.state.editingWorkouts}
                        selectedWeeks={this.state.selectedWeeks}
                        handleSelectWeek={this.handleSelectWeek}
                      />
                    )
                  )}

                {locals.query.readOnly !== true &&
                  Array.from({ length: numberOfWeeks }, (_, i) => i + 1).map(
                    (nWeek) => (
                      <EditorWeekColumn
                        key={`week_column_program_editor_${nWeek.toString()}`}
                        week={weeks[nWeek.toString()]}
                        exercises={this.state.exercises || []}
                        cycle={locals.editCycle}
                        program={locals.program}
                        programNumber={programNumber}
                        programOrder={locals.query.program}
                        activeWeek={locals.activeWeek}
                        column={nWeek.toString()}
                        fromMetric={locals.fromMetric}
                        activeUser={activeUser}
                        numberOfWeeks={numberOfWeeks}
                        scrollTo={scrollTo}
                        updateExercise={this.updateExercise}
                        deleteExercise={this.deleteExercise}
                        updateExercises={this.updateExercises}
                        updateOrderExercises={this.updateOrderExercises}
                        workoutOpacityCallback={this.workoutOpacityCallback}
                        editingWorkouts={this.state.editingWorkouts}
                        selectedWeeks={this.state.selectedWeeks}
                        handleSelectWeek={this.handleSelectWeek}
                      />
                    )
                  )}
              </ul>
            )}

            {this.state.viewportWidth <= 960 && (
              <>
                <div role="week-selector">
                  <button
                    data-button-type="text-white"
                    data-icon-only="true"
                    onClick={() => {
                      this.state.nWeekSelected > 1 &&
                        this.setState({
                          nWeekSelected: this.state.nWeekSelected - 1,
                        });
                    }}
                  >
                    <picture class="">
                      <img src="/img/new-icons/arrow-left.svg" />
                    </picture>
                  </button>
                  <span>
                    {t("athlete-portal:programs.weekN", {
                      n: this.state.nWeekSelected,
                    })}
                  </span>
                  <button
                    data-button-type="text-white"
                    data-icon-only="true"
                    onClick={() => {
                      this.state.nWeekSelected < numberOfWeeks &&
                        this.setState({
                          nWeekSelected: this.state.nWeekSelected + 1,
                        });
                    }}
                  >
                    <picture class="">
                      <img src="/img/new-icons/arrow-right.svg" />
                    </picture>
                  </button>
                </div>
                <ul
                  className={`weeks ${
                    numberOfWeeks == locals.activeWeek ? "alt-last" : ""
                  } only-show-mobile`}
                >
                  {queryIsWeekAuthoring &&
                    locals.query.readOnly === true &&
                    Array.from({ length: numberOfWeeks }, (_, i) => i + 1).map(
                      (nWeek) => (
                        <ReadOnlyWeekColumn
                          key={`week_column_program_editor_${this.state.nWeekSelected.toString()}`}
                          week={weeks[this.state.nWeekSelected.toString()]}
                          exercises={this.state.exercises || []}
                          cycle={locals.editCycle}
                          program={locals.program}
                          programNumber={programNumber}
                          programOrder={locals.query.program}
                          activeWeek={locals.activeWeek}
                          column={this.state.nWeekSelected.toString()}
                          fromMetric={locals.fromMetric}
                          activeUser={activeUser}
                          numberOfWeeks={numberOfWeeks}
                          scrollTo={scrollTo}
                          updateExercise={this.updateExercise}
                          deleteExercise={this.deleteExercise}
                          updateExercises={this.updateExercises}
                          updateOrderExercises={this.updateOrderExercises}
                          workoutOpacityCallback={this.workoutOpacityCallback}
                          editingWorkouts={this.state.editingWorkouts}
                          selectedWeeks={this.state.selectedWeeks}
                          handleSelectWeek={this.handleSelectWeek}
                        />
                      )
                    )}

                  {locals.query.readOnly !== true && (
                    <EditorWeekColumn
                      key={`week_column_program_editor_${this.state.nWeekSelected.toString()}`}
                      week={weeks[this.state.nWeekSelected.toString()]}
                      exercises={this.state.exercises || []}
                      cycle={locals.editCycle}
                      program={locals.program}
                      programNumber={programNumber}
                      programOrder={locals.query.program}
                      activeWeek={locals.activeWeek}
                      column={this.state.nWeekSelected.toString()}
                      fromMetric={locals.fromMetric}
                      activeUser={activeUser}
                      numberOfWeeks={numberOfWeeks}
                      scrollTo={scrollTo}
                      updateExercise={this.updateExercise}
                      deleteExercise={this.deleteExercise}
                      updateExercises={this.updateExercises}
                      updateOrderExercises={this.updateOrderExercises}
                      workoutOpacityCallback={this.workoutOpacityCallback}
                      editingWorkouts={this.state.editingWorkouts}
                      selectedWeeks={this.state.selectedWeeks}
                      handleSelectWeek={this.handleSelectWeek}
                    />
                  )}
                </ul>
              </>
            )}
          </section>

          {showProgramInsightsShell && (
            <ProgramInsightsShell
              key={`${cycleId}-${programNumber}`}
              cycleId={cycleId}
              builderScrollRef={this.mainSectionRef}
              builderWeeks={teamsProgramInsightsInput?.builderWeeks ?? weeks}
              programExercises={
                teamsProgramInsightsInput?.programExercises ??
                this.state.exercises
              }
              weekHeaderLabels={teamsProgramInsightsInput?.weekHeaderLabels}
              fromMetric={locals.fromMetric}
              coachPreferences={{
                ...locals.activeUserToRequest,
                defaultInsightsLens: effectiveInsightsLens,
              }}
            />
          )}
        </div>

        {configuration == "weeks" && (
          <WeekConfiguration
            weeks={weeks}
            cycleId={cycleId}
            programNumber={programNumber}
            handleDiscard={() => this.setState({ configuration: false })}
          />
        )}
        {configuration == "workouts" && (
          <WorkoutConfiguration
            weeks={weeks}
            cycleId={cycleId}
            programNumber={programNumber}
            handleDiscard={() => this.setState({ configuration: false })}
          />
        )}
        {isCoach && (
          <ExerciseClipboardContent
            query={exercisesInClipboard}
            locals={locals}
          />
        )}
        <InsertUndoToast cycleId={cycleId} />
      </main>
    );
  }
}

View.contextType = RillContext;

export default withTranslation(["athlete-portal", "common"])(View);
